import type { ReactNode } from 'react';
import { Wordmark } from '@/component';
import { pickHeroLine } from '@/model/heroLines';

interface SignedOutLayoutProps {
  /** Third block of the left column, under the hero. Left out, the hero keeps
   * its place and the slot stays empty. */
  aside?: ReactNode;
  /** The surface column: a Clerk card and the small print under it. */
  children: ReactNode;
}

/** The handoff's signed-out frame: wordmark, the day's hero line and one more
 * block down the left; a fixed 420px surface column on the right for whichever
 * Clerk card the page mounts. Below lg the surface column comes first. */
export function SignedOutLayout({ aside, children }: SignedOutLayoutProps) {
  const line = pickHeroLine();
  return (
    <div className="grid min-h-screen grid-cols-1 lg:grid-cols-[minmax(0,1fr)_420px]">
      <div className="flex flex-col justify-between gap-14 px-6 py-12 lg:px-14 lg:py-[72px]">
        <Wordmark size="lg" />
        <div>
          <h1 className="max-w-[20ch] text-[40px] font-semibold leading-[1.02] tracking-[-0.035em] lg:text-[56px]">
            {line.title}
          </h1>
          <p className="mt-[22px] max-w-[48ch] text-[17px] leading-[1.55] text-mute">{line.subtitle}</p>
        </div>
        {aside ?? <div aria-hidden />}
      </div>
      <div className="order-first flex flex-col justify-center border-b border-line bg-surface px-6 py-12 lg:order-none lg:border-b-0 lg:border-l lg:px-12 lg:py-[72px]">
        {children}
      </div>
    </div>
  );
}
